<template>
  <van-popup
    v-model="isShow"
    position="bottom"
  >
    <div class="data_list">
      <div style="margin-bottom:0.8rem;">请选择预约日期</div>
      <div class="data_check_box">
        <div class="empty_box" v-if="dataList.length === 0 && config.waiBed.indexOf(area) === -1">
          暂无可用信息
        </div>
        <div :class="[current_data_index === index ? ['data_box_select','data_box'] : ['data_box']]"
             v-for="(item,index) in dataList"
             @click="checkDate(index)">
          <div style="width: 100%;margin-bottom:0.2rem;color: #333;font-weight: 600;">{{ item.reserve_date }}</div>
          <div style="width: 100%;margin-bottom:0.3rem;color: #666;font-weight: 600;">{{ item.week }}</div>
          <div style="width: 100%;text-align: center;"><span
            style="font-weight: 300;font-size:0.8rem;"> 剩余床位 </span>
            <span
              style="font-weight: 900;color: #1f77d8;font-size: 1.5rem">{{
                item.reserve_total - item.reserve_used
              }} </span>
          </div>
        </div>
        <div v-if="config.waiBed.indexOf(area) > -1"
             :class="[current_data_index === -1 ? ['data_box_select','data_box'] : ['data_box']]"
             @click="checkDate(-1)">
          <div style="width: 100%;margin-bottom:0.2rem;color: #333;font-weight: 600;">随机分配</div>
          <div style="width: 100%;margin-bottom:0.3rem;color: #666;font-weight: 600;">-</div>
          <span
            style="font-weight: 900;color: #1f77d8;font-size: 1.2rem">等待排床</span>
        </div>
      </div>
      <van-button type="info" style="width: 100%;" @click="confirmDate">确认选择</van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'bedChoose',
  props: ['area'],
  data() {
    return {
      config: {
        waiBed: []
      },
      current_data_index: undefined,
      current_data: undefined,
      dataList: [],
      orderDate: null,
      isShow: false
    }
  },
  watch: {
    area(n, o) {
      this.loadData()
    }
  },
  mounted() {
    this.getConfig()
  },
  methods: {
    onShow(v) {
      this.isShow = true
      if(v) {
        this.orderDate = v
      }
      this.loadData()
      this.getConfig()
    },
    onHide() {
      this.isShow = false
    },
    checkDate(i) {
      this.current_data_index = i;
    },
    getConfig() {
      let self = this;
      this.$http.post('/client/config', {}).then(function (response) {
        if (response.data.code === 0) {
          self.config = response.data.data
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadData() {
      let self = this;
      this.$http.post('/client/schedule', {
        area: this.area
      }).then(function (response) {
        if (response.data.code === 0) {
          self.dataList = response.data.data
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    confirmDate() {
      if (this.current_data_index === -1) {
        this.orderDate = null
        this.isShow = false;
      } else {
        this.orderDate = this.dataList[this.current_data_index].reserve_date
        this.isShow = false;
      }
      this.$emit('onChoose', {
        orderDate: this.orderDate,
        current_data_index: this.current_data_index
      })
    },
  }
}
</script>

<style scoped>


.pop_box {
  width: calc(100% - 16px);
  border: 1px solid #909399;
  height: 2.5rem;
  display: flex;
  align-items: center;
  padding-left: 16px;
  /*justify-content: center;*/
}

.data_list {
  width: calc(100% - 1.6rem);
  padding: 0.8rem;

}

.data_check_box {
  width: 100%;
  overflow-y: scroll;
  height: 55vh;
  /*justify-content: center;*/
}

.data_box {
  padding: 0.8rem 0.2rem;
  margin-right: 2%;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  width: 31%;
  text-align: center;
  border: 1px solid #909399;
  float: left;
  height: 120px;
}

.data_box_select {
  background: #f1fedb;
}

/deep/ .van-cell {
  border: 1px solid #909399;
}

/deep/ .van-radio {
  border: 1px solid #909399;
  padding: 10px 16px;
}

.empty_box {
  width: 100%;
  line-height: 300px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BedChoose.vue